module.exports = __webpack_public_path__ + "img/award_RedDotWinner2022@2x.51bd1a52.png";